import {createSlice, createAsyncThunk, current} from "@reduxjs/toolkit";

const initialState = {
    isCompleted: false,
    isSignalRLinked: false
};

const appInitSlice = createSlice({
    name: "appInit",
    initialState: initialState,
    reducers:{
        setAppInitCompleted: (state, action) => ({...state, isCompleted: action.payload}),
        setSignalRLinkedCompleted: (state, action) => ({...state, isSignalRLinked: action.payload})
    }
});

export default appInitSlice.reducer;

export const { setAppInitCompleted, setSignalRLinkedCompleted } = appInitSlice.actions;

